import SpriteSymbol from "../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dot3",
  "use": "dot3-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"dot3\">\n<circle cx=\"10\" cy=\"16\" r=\"1.5\" transform=\"rotate(90 10 16)\" />\n<circle cx=\"10\" cy=\"10\" r=\"1.5\" transform=\"rotate(90 10 10)\" />\n<circle cx=\"10\" cy=\"4\" r=\"1.5\" transform=\"rotate(90 10 4)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol